import React, { useState } from "react"
import BaseShapeRoundedRect from "./BaseShapeRoundedRect"
import * as common from "./common"
import { yellow } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const BusinessFunction = (props) => {
    const { x, y, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = yellow[200]
    const defaultColor = fillColor || yellow[100]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            
            <BaseShapeRoundedRect {...props} fill={fill} setFill={handleFill} />

            <svg x={x+3} y={y+1}>
                <path
                    d={`M${width - 25},${10} ${common.markers["chevronUp"]} z`}
                    stroke={common.outlineColor}
                    fill='none'
                />
            </svg>

            <ElementText {...props} label={label} />
        </Svg>
    )
}

export default BusinessFunction
